module.exports = __webpack_public_path__ + "static/media/ABELCoaches_Norge.8bfe94fc.png";